import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
export function isDropdownGroup(object) {
    return 'items' in object && Array.isArray(object.items) && object.items.length;
}
export function isNullableDropdownGroup(object) {
    return 'items' in object && Array.isArray(object.items);
}
export function isSelectableDropdownOption(object) {
    return 'value' in object;
}
export function convertNullableGroupToDropdownGroup(group) {
    const items = group.items.filter((item)=>!!item);
    return items.length > 0 ? _object_spread_props(_object_spread({}, group), {
        items
    }) : undefined;
}
export function filterNullableDropdownItems(items) {
    return items.map((item)=>item && (isNullableDropdownGroup(item) ? convertNullableGroupToDropdownGroup(item) : item)).filter((item)=>!!item);
}
export function findSelectedItem(items, lookInGroups = true) {
    let selectedItem;
    for (const item of items){
        if (isDropdownGroup(item)) {
            if (lookInGroups) {
                selectedItem = findSelectedItem(item.items, false);
            }
        } else if (item.selected) {
            selectedItem = item;
        }
        if (selectedItem) {
            break;
        }
    }
    return selectedItem;
}
export function updateSelectionByValue(value, items, lookInGroups = true) {
    if (!value) {
        return items;
    }
    const updatedItems = [];
    for (const item of items){
        if (isDropdownGroup(item)) {
            updatedItems.push({
                items: updateSelectionByValue(value, item.items, false)
            });
        } else {
            if (item && isSelectableDropdownOption(item)) {
                item.selected = item.value === value;
            }
            updatedItems.push(item);
        }
    }
    return updatedItems;
}
export function findItemByValue(value, items, lookInGroups = true) {
    if (value === undefined) {
        return undefined;
    }
    let matchingItem;
    for (const item of items){
        if (isDropdownGroup(item)) {
            if (lookInGroups) {
                matchingItem = findItemByValue(value, item.items, false);
            }
        } else if (getItemValue(item) === value) {
            matchingItem = item;
        }
        if (matchingItem) {
            break;
        }
    }
    return matchingItem;
}
export function getItemValue(item) {
    return item.value !== undefined ? item.value : item.link;
}
export function getSelectedItemByValue(value, items) {
    if (value !== undefined) {
        return getFlatItemList(items).find((item)=>getItemValue(item) === value);
    }
    return undefined;
}
export function hasSubmenus(items) {
    return getFlatItemList(filterNullableDropdownItems(items)).some((item)=>!!item.submenu);
}
function getFlatItemList(items) {
    let flatItems = [];
    items.forEach((item)=>{
        if (isDropdownGroup(item)) {
            flatItems = flatItems.concat(item.items);
        } else {
            flatItems = flatItems.concat([
                item
            ]);
        }
    });
    return flatItems;
}
